// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4015":"bb316c81c50a5d4c","8598":"84580a5a660eff01"}[chunkId] + ".css";
};